// src/utils/config.js
export const DEFAULT_CONFIG = {
  categories:          ["CRM", "HR", "Finance", "DevTools", "Communication", "Security", "Marketing", "Productivity", "IT Operations", "Other"],
  auditIntervals:      [1, 2, 3, 6, 12],
  authTypes:           ["AD Credentials", "Entra Credentials", "Individual Credentials", "Shared Credentials"],
  systemTypes:         ["Desktop Application", "Web Application"],
  defaultAccessLevels: ["Admin", "Editor", "Viewer", "Read-Only", "Billing", "Support"],
};

export async function loadConfig() {
  try {
    const res  = await fetch("/api/config");
    if (!res.ok) return DEFAULT_CONFIG;
    const data = await res.json();
    return {
      categories:     data.categories?.length     ? data.categories     : DEFAULT_CONFIG.categories,
      auditIntervals: data.auditIntervals?.length  ? data.auditIntervals : DEFAULT_CONFIG.auditIntervals,
      authTypes:      data.authTypes?.length       ? data.authTypes      : DEFAULT_CONFIG.authTypes,
      systemTypes:         data.systemTypes?.length         ? data.systemTypes         : DEFAULT_CONFIG.systemTypes,
      defaultAccessLevels: data.defaultAccessLevels?.length ? data.defaultAccessLevels : DEFAULT_CONFIG.defaultAccessLevels,
    };
  } catch {
    return DEFAULT_CONFIG;
  }
}

export async function saveConfig(config) {
  const res = await fetch("/api/config", {
    method:  "POST",
    headers: { "Content-Type": "application/json" },
    body:    JSON.stringify(config),
  });
  if (!res.ok) throw new Error("Failed to save configuration");
  return res.json();
}
